import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className='footer-container'>
      <p>© 2023 Megan DeRisi | Mike Chavez | Peter Ji</p>
    </footer>
  )
}

export default Footer